import * as React from "react";
import { Slot } from "@radix-ui/react-slot";
import { cva } from "class-variance-authority";
import { cn } from "@/lib/utils";

const badgeVariants = cva("inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium whitespace-nowrap [&_svg]:size-3 [&_svg]:shrink-0", {
  variants: {
    variant: {
      default: "bg-primary-muted text-primary border-primary/20",
      primary: "bg-primary-muted text-primary border-primary/20",
      neutral: "bg-slate-100 text-slate-700 border-slate-200",
      secondary: "bg-slate-100 text-slate-700 border-slate-200",
      outline: "bg-white text-slate-700 border-slate-200",
      success: "bg-success-muted text-success-muted-foreground border-success/20",
      warning: "bg-warning-muted text-warning-muted-foreground border-warning/20",
      info: "bg-info-muted text-info-muted-foreground border-info/20",
      destructive: "bg-destructive-muted text-destructive-muted-foreground border-destructive/20",
      turkuaz: "bg-turkuaz-muted text-turkuaz-muted-foreground border-turkuaz/20",
      violet: "bg-violet-50 text-violet-700 border-violet-200",
      dark: "bg-slate-200 text-slate-800 border-slate-300",
    },
    size: { default: "", sm: "px-1.5 py-0 text-2xs" },
    interactive: { true: "cursor-pointer transition-colors hover:brightness-95 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/30 disabled:pointer-events-none disabled:opacity-50", false: "" },
    mono: { true: "font-mono tabular-nums", false: "" },
  },
  defaultVariants: { variant: "default", size: "default", mono: false },
});
/** variant: durum tonu; size: default|sm; mono: sayısal metin; interactive: buton hover/focus durumu; asChild: tek çocuğu biçimlendirir.
 * @example <Badge variant="success" size="sm">Onaylandı</Badge>
 */
const Badge = React.forwardRef(({ className, variant, size, mono, interactive = false, asChild = false, ...props }, ref) => {
  const Comp = asChild ? Slot : "div";
  return <Comp ref={ref} className={cn(badgeVariants({ variant, size, mono, interactive }), className)} {...props} />;
});
Badge.displayName = "Badge";
export { Badge, badgeVariants };
